import { v4 as uuidV4 } from 'uuid';

import { ProtocolFactory } from 'lib/protocols';

import { EPropType } from '@types';

import { BaseInputParts, BaseInputProps } from './index';

export const protocolFactory = new ProtocolFactory<BaseInputProps, BaseInputParts>({
  name: 'BaseInput',
  editorProps: [
    {
      type: EPropType.String,
      name: 'name',
      required: false,
      label: 'Name',
      description: 'Name of the input',
      defaultValue: uuidV4(),
    },
    {
      type: EPropType.String,
      name: 'label',
      required: false,
      label: 'Label',
      description: 'The label of the input inside of the form control',
      defaultValue: 'Example',
    },
    {
      type: EPropType.String,
      name: 'placeholder',
      required: false,
      label: 'Placeholder',
      description: 'Text inside the input if no value is provided',
      defaultValue: 'Insert some text here',
    },
  ],
  themeConfig: {
    allowMultipart: true,
    defaultProps: ['size', 'variant'],
    sizes: ['sm', 'md', 'lg'],
    parts: ['base-input-label', 'base-input-control'],
    partsConfig: {
      'base-input-label': {
        variantProps: ['color', 'fontWeight'],
        sizeProps: ['fontSize', 'marginBottom'],
      },
      'base-input-control': {
        pseudos: ['_hover', '_invalid', '_disabled'],
        pseudoProps: ['color', 'background', 'border', 'borderColor', 'borderRadius'],
        variantProps: ['color', 'background', 'border', 'borderColor', 'borderRadius'],
        sizeProps: ['fontSize', 'paddingHorizontal', 'paddingVertical'],
      },
    },
  },
});

export const defaultProps = protocolFactory.createDefaultProps();
